import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
import { computed } from 'vue';
import wifi1 from '@/assets/network/wifi1.svg';
import wifi2 from '@/assets/network/wifi2.svg';
import wifi3 from '@/assets/network/wifi3.svg';
import wifi4 from '@/assets/network/wifi4.svg';
export default /*#__PURE__*/_defineComponent({
  __name: 'networkdelay',
  props: {
    networkdelayBarMsg: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  setup(__props) {
    const props = __props;
    const networkState = computed(() => {
      let returnState = wifi4;
      const networkdelay = props.networkdelayBarMsg.delay;
      if (0 < networkdelay && networkdelay < 100) {
        returnState = wifi1;
      } else if (networkdelay >= 100 && networkdelay < 200) {
        returnState = wifi2;
      } else if (networkdelay >= 200 && networkdelay < 500) {
        returnState = wifi3;
      } else if (networkdelay >= 500) {
        returnState = wifi4;
      }
      return returnState;
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, {
        placement: "bottom",
        content: '延迟：' + __props.networkdelayBarMsg.delay + 'ms'
      }, {
        default: _withCtx(() => [networkState.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: networkState.value
        }, null, 8, _hoisted_1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["content"]);
    };
  }
});